import { BackIcon } from '@euler/app/components/icons/BackIcon';
import { InspectionSiteSearchScreen } from '@euler/app/flows/task/pages/inspection/InspectionSiteSearchScreen';
import { wrapTaskNavigatorScreen } from '@euler/app/flows/task/wrapTaskNavigatorScreen';
import { MultilineHeaderTitle } from '@euler/components/MultilineHeaderTitle';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ScreenToParams, spreadScreens } from '@euler/functions/spreadScreens';
import { InspectionTemplate } from '@euler/model';
import { createStackNavigator } from '@react-navigation/stack';
import { useTheme } from 'styled-components';
import { InspectionTemplatePreviewScreen } from './InspectionTemplatePreviewScreen';

const Stack = createStackNavigator();

const Screens = {
  _main: InspectionTemplatePreviewScreen,
  _inspectionSiteSearch: InspectionSiteSearchScreen,
};

export type InspectionTemplatePreviewNavParams = ScreenToParams<typeof Screens>;

type Props = {
  template: InspectionTemplate;
};

export const InspectionTemplatePreviewFlow = wrapTaskNavigatorScreen(
  (props: Props) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();

    return (
      <Stack.Navigator
        initialRouteName="_main"
        screenOptions={{
          headerMode: 'float',
          headerTitleAlign: 'center',
          headerBackTitle: ' ',
          headerTitleStyle: {
            fontSize: rpx(18),
            fontFamily: FontFamily.NotoSans.Bold,
          },
          cardStyle: {
            backgroundColor: theme.page.card.backgroundColor,
          },
          headerTitle: MultilineHeaderTitle,
          headerBackImage: () => <BackIcon />,
        }}
      >
        {spreadScreens(Stack.Screen, Screens, '_main', props)}
      </Stack.Navigator>
    );
  },
  {},
  { aside: true },
);
